import React, { useState } from "react";
import styled from "styled-components";
import { rem } from "polished";
import mq from "../../../helpers/media-queries";

import Headline from "./HeadlineWithDiscount";
import Breadcrumbs from "./Breadcrumbs";
import KeyFeatures from "./KeyFeatures";
import SpecsTable from "./SpecsTable";
import OrderSummary from "./OrderSummary";
import Bottom from "../../Bottom/Bottom";
import ColorPicker from "./ColorPicker";
import Price from "./Price";
import Accessories from "./Accessories";

const Container = styled.div`
	${mq("sm", "min")} {
		width: ${rem(420)};
		flex-shrink: 0;
		height: 100%;
		display: flex;
		background: #fff;
		display: flex;
		flex-direction: column;
		box-shadow: -4px 10px 14px rgba(0, 0, 0, 0.04);
		position: relative;
		z-index: 10;
		border-left: 1px solid #eaeaea;
		position: relative;
	}
`;

const Content = styled.div`
	${mq("sm", "max")} {
		padding: ${rem(17)};
	}

	${mq("sm", "min")} {
		padding: ${rem(40)};
		flex: 1;
		overflow-y: scroll;
		padding-top: ${rem(50)};

		display: flex;
		flex-direction: column;
	}
`;
const Button = styled.button`
	background: #cc6f4c;
	width: 100%;
	padding: ${rem(14)};
	border: 0;
	appearance: none;
	color: white;
	font-size: 20px;
	border-radius: 5px;
	cursor: pointer;
	font-family: sans-serif;
	transition: 0.3s;

	&:hover {
		background: #231914;
	}

	&[disabled] {
		opacity: 0.2;
		cursor: not-allowed;
	}

	&:focus {
		outline: none;
	}
`;

const Title = styled.h3`
	font-family: sans-serif !important;
	font-size: ${rem(24)};
	line-height: 1.3;
	font-weight: 400;
	font-family: sans-serif;
	border-top: 1px solid #dbdbdb;
	padding-top: ${rem(10)};

	em {
		color: #9e3f3a;
	}
`;

const SubTitle = styled.p`
	font-size: ${rem(17)};
	font-family: sans-serif;
`;

const Text = styled.div`
	font-size: ${rem(13)};
	line-height: 1.5;
	color: #5c5e62;
	padding-top: ${rem(10)};
	margin-bottom: ${rem(16)};

	& > * + * {
		margin-top: ${rem(10)};
	}
`;

const Sidebar = ({
	popupOpen,
	setPopupOpen,
	color,
	setColor,
	linerColor,
	handleAddToCart,
	details,
	specs,
	keyFeaturesData,
	headlineData,
	breadcrumbData,
	price,
	setModelId,
	activeAccessories,
	setActiveAccessories,
}) => {
	return (
		<Container>
			<Content>
				<Breadcrumbs links={breadcrumbData} hideMobile={true} />
				<Headline data={headlineData} hideMobile={true} />
				{linerColor && (
					<ColorPicker
						options={linerColor}
						color={color}
						setColor={setColor}
						setModelId={setModelId}
					/>
				)}
				<Price oldPrice={details.base.oldPrice} newPrice={details.base.price} />
				<KeyFeatures
					data={keyFeaturesData}
					popupOpen={popupOpen}
					setPopupOpen={setPopupOpen}
				/>
				<SpecsTable tableData={specs} />
				{details.accesories && (
					<Accessories
						data={details.accesories}
						onCheck={setActiveAccessories}
						activeAccessories={activeAccessories}
						price={price}
					/>
				)}
				<OrderSummary
					price={price}
					details={details}
					active={activeAccessories}
					color={color}
					colorOptions={linerColor}
				/>
			</Content>

			<Bottom
				title={headlineData.title}
				isCheckout={true}
				inStock={true}
				showDetails={true}
				totalPrice={price}
				onAddToCart={handleAddToCart}
			/>
		</Container>
	);
};

export default Sidebar;
